import { render, staticRenderFns } from "./VolvoFHDashboard.vue?vue&type=template&id=76380ebe&"
import script from "./VolvoFHDashboard.vue?vue&type=script&lang=js&"
export * from "./VolvoFHDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports